/**
 * SpamBlockRow - one row in the AdminSpamPage sender-block table (12.8).
 *
 * Columns: pattern, kind badge, reason, blocked_by_user_id (mono),
 * created_at, Remove button. Remove invokes a parent-supplied callback
 * that runs the confirm modal.
 */
import { Badge, Button } from "@/components/ui";
import type { SenderBlockResponse } from "@/types/api";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString();
}

export interface SpamBlockRowProps {
  row: SenderBlockResponse;
  onRemove: (block: SenderBlockResponse) => void;
  isRemoving?: boolean;
}

export function SpamBlockRow({
  row,
  onRemove,
  isRemoving = false,
}: SpamBlockRowProps): JSX.Element {
  return (
    <tr className="hover:bg-neutral-50">
      <td className="px-3 py-2 font-mono text-xs text-neutral-900 break-all">
        {row.pattern}
      </td>
      <td className="px-3 py-2 text-xs">
        <Badge variant={row.kind === "email" ? "info" : "warning"}>
          {row.kind.toUpperCase()}
        </Badge>
      </td>
      <td className="px-3 py-2 text-xs text-neutral-700">
        {row.reason ?? <span className="text-neutral-300">-</span>}
      </td>
      <td className="px-3 py-2 font-mono text-[11px] text-neutral-500">
        {row.blocked_by_user_id ? (
          <span title={row.blocked_by_user_id}>
            {row.blocked_by_user_id.slice(0, 8)}
          </span>
        ) : (
          <span className="text-neutral-300">-</span>
        )}
      </td>
      <td className="whitespace-nowrap px-3 py-2 text-xs text-neutral-500">
        {formatDate(row.created_at)}
      </td>
      <td className="px-3 py-2 text-right">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onRemove(row)}
          disabled={isRemoving}
        >
          Remove
        </Button>
      </td>
    </tr>
  );
}

export default SpamBlockRow;
